import { t } from "i18next";
import { formatNumberCz } from "../utils/NumberUtils";
import { formatWeekdayDateCz } from "../utils/DateUtils";

const PaymentsTable = {
  recalculateSumsXhrRequest: null,

  hasErrorMessage: () => !$('#payment-table-error-message').is(':empty'),

  markTableObsolete: () => !PaymentsTable.hasErrorMessage()
    ? $('#payment-table-error-message').html(t('invoice.paymentsTable.error.sumsAreObsolete'))
    : false,

  init: () => {
    $('button#trigger-payment-table').on('click', function (event) {
      $('#payment-table-container').toggle();
    });

    const payDateFrom = $('input[name="payDateFrom"]');
    const payDateTo = $('input[name="payDateTo"]');

    const basePayDateFrom = payDateFrom.attr('data-default-date-from');
    const basePayDateTo = payDateTo.attr('data-default-date-to');

    payDateFrom.datepicker({
      dateFormat: 'dd.mm.yy', // let's not confuse them with local formats for now
      altFormat: 'yy-mm-dd',
      altField: "#altPayDateFrom",
      maxDate: basePayDateTo,
        onClose: function (selectedDate) {
          if (!selectedDate) {
            payDateFrom.datepicker('setDate', basePayDateFrom)
          }
          payDateTo.datepicker('option', 'minDate', selectedDate);
        }
    }).datepicker('setDate', basePayDateFrom);
    payDateTo.datepicker({
      dateFormat: 'dd.mm.yy', // again, let's not confuse them with local formats for now
      altFormat: 'yy-mm-dd',
      altField: "#altPayDateTo",
      minDate: basePayDateFrom,
        onClose: function (selectedDate) {
          if (!selectedDate) {
            payDateTo.datepicker('setDate', basePayDateTo);
          }
          payDateFrom.datepicker('option', 'maxDate', selectedDate)
        }
    }).datepicker('setDate', basePayDateTo);

    const altPayDateFrom = $('input[name="altPayDateFrom"]');
    const altPayDateTo = $('input[name="altPayDateTo"]');

    payDateFrom.on('change', function (event) {
      PaymentsTable.recalculateSums(
          altPayDateFrom.val(),
          altPayDateTo.val(),
      )
    });
    payDateTo.on('change', function (event) {
      PaymentsTable.recalculateSums(
          altPayDateFrom.val(),
          altPayDateTo.val(),
      )
    }).trigger('change');

    $('form#payment-form button').on('click', function (event) {
      event.preventDefault();

      const button = $(this);
      PaymentsTable.paymentExport(button.attr('name'), button.attr('data-action'));
    });
  },

  recalculateSums: (dateFrom, dateTo) => {
    if (PaymentsTable.recalculateSumsXhrRequest !== null) {
      PaymentsTable.recalculateSumsXhrRequest.abort();
      PaymentsTable.recalculateSumsXhrRequest = null;
    }

    const paymentTableWrapper = $('div#payment-table-wrapper');
    paymentTableWrapper.html('');
    const loadingSpinner = $('div#payment-table-loading-spinner');
    loadingSpinner.show();
    const errorMessage = $('div#payment-table-error-message');
    errorMessage.html('');

    PaymentsTable.recalculateSumsXhrRequest = $.get(
      '/admin-zas/invoices/paymentTableData?dateFrom=' + dateFrom + '&dateTo=' + dateTo, // todo: refactor url
      function (response) {
        const dataByDates = response['data'];
        const paymentSubtableTemplate = $('#payment-subtable-template');
        Object.keys(dataByDates).forEach(function (currency) {
          const dataByDatesOneCurrency = dataByDates[currency]['toPayByDates'];

          const subtableForCurrency = paymentSubtableTemplate.clone();
          subtableForCurrency.attr('id', 'payment-subtable-' + currency.toLowerCase());
          subtableForCurrency.find('#currency-title-template')
            .attr('id', 'currency-title-' + currency.toLowerCase())
            .html(currency);

          const toPayBefore = dataByDates[currency]['toPayBefore'];
          const toPayLater = dataByDates[currency]['toPayLater'];

          subtableForCurrency.find('table').before(
              `
                  <div class="mb-1">${ t('invoice.paymentsTable.sumBefore') } ${ formatNumberCz(toPayBefore) }</div>
              `
          );
          subtableForCurrency.find('table').after(
              `
                  <div class="mt-1">${ t('invoice.paymentsTable.sumAfter') } ${ formatNumberCz(toPayLater) }</div>
              `
          );

          // all in CZ because we don't wanna confuse Financial Department with different locale formats
          Object.keys(dataByDatesOneCurrency).forEach(function (date) {
            const { remaining: remaining, total: total } = dataByDatesOneCurrency[date];
            subtableForCurrency.find('tbody').append(
              `
                  <tr>
                      <td>${ formatWeekdayDateCz(date) }</td>
                      <td>${ formatNumberCz(remaining) }</td>
                      <td>${ formatNumberCz(total) }</td>
                  </tr>
              `
            );
          });

          const returnAmount = dataByDates[currency]['returnAmount'];
          subtableForCurrency.find('tbody').append(
              `
                  <tr>
                      <td colspan="2">${ t('invoice.paymentsTable.returnAmount') }</td>
                      <td>${ formatNumberCz(returnAmount) }</td>
                  </tr>
              `
          );

          const selectedSumToPayNow = dataByDates[currency]['toPayNow'];
          const selectedSumToPayAll = dataByDates[currency]['toPayAll'] - toPayBefore - toPayLater;

          subtableForCurrency.find('tfoot').append(
            `
              <tr>
              <td>${ t('global.sum') }</td>
              <td>${ formatNumberCz(selectedSumToPayNow) }</td>
              <td>${ formatNumberCz(selectedSumToPayAll) }</td>
              </tr>
            `
          );

          subtableForCurrency.appendTo('div#payment-table-wrapper');
          subtableForCurrency.show();
        });
      }).fail(function (response) {
      let error = t('global.errorInternal');
      // yeah, well, its nette response from presenter for custom latte and json is under key 'responseJSON', will be fixed with module refactor
      if (response['responseJSON'] && response['responseJSON']['error']) {
        error = response['responseJSON']['error'];
      }
      errorMessage.html(error);
    }).always(function () {
      loadingSpinner.hide();
    });
  },

  paymentExport: (name, action) => {
    const form = $('form#payment-form');

    form.attr('action', '/admin-zas/invoice/' + action);
    form.submit();
  },
};

$(function() {
  PaymentsTable.init();
});

export default PaymentsTable;
